// Utility functions for customer management

// Simple debounce function
export const debounce = (func: Function, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

// Function to get the 5th of next month
export const getNextMonth5th = () => {
  const now = new Date();
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 5, 12, 0, 0, 0);
  return nextMonth.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

// Check if field is required
export const isRequiredField = (fieldName: string) => {
  const requiredFields = ['CustomerID', 'CustomerName', 'DirectorRegister', 'DrFirstname', 'DrLastname'];
  return requiredFields.includes(fieldName);
};

// Validate required fields
export const validateRequiredFields = (form: any) => {
  const requiredFields = ['CustomerID', 'CustomerName', 'DirectorRegister', 'DrFirstname', 'DrLastname'];
  return requiredFields.every(field => form[field] && form[field].trim() !== '');
};

// Check if value is valid GUID
export const isValidGuid = (value: string) => {
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return guidRegex.test(value);
};

// Get tab index for field
export const getTabIndex = (fieldKey: string) => {
  const tabIndexMap: { [key: string]: number } = {
    'CustomerID': 1,
    'CustomerName': 2,
    'DirectorRegister': 3,
    'DrFirstname': 4,
    'DrLastname': 5,
    'TinCode': 6,
    'BusinessClassOid': 7,
    'RegionId': 8,
    'RegionSubId': 9,
    'Address': 10,
    'Phone': 11,
    'Mail': 12,
    'TaxLoginOid': 13,
    'InsuranceLoginId': 14,
    'DigitalSignaturePassword': 15,
    'DigitalCertFilePath': 16,
    'ContractAmount': 17,
    'Contract_Time': 18,
    'ContractEndDate': 19,
    'UserName': 20,
    'TaxName': 21
  };
  return tabIndexMap[fieldKey] || 99;
};

// Normalize Cyrillic text for comparison
export const normalizeCyrillicText = (text: string) => {
  return text
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/й/g, 'и')
    .trim();
};

// Extract numeric part from text
export const extractNumericPart = (text: string) => {
  return text.replace(/[^\d]/g, '');
};

// Transform customer data
export const transformCustomerData = (customers: Customer[]) => {
  return customers.map(customer => ({
    ...customer,
    // Add any data transformation logic here
  }));
};

// Customer interface
export interface Customer {
  CustomerID: string;
  CustomerName: string;
  TIN?: string;
  Phone?: string;
  Email?: string;
  EBarimtRegistered?: boolean;
  NDRegistered?: boolean;
  TaxRegistered?: boolean;
  Active?: boolean;
  [key: string]: any;
}



